module.exports = __webpack_public_path__ + "static/media/Invoice-template.306b0d95.png";